import { render } from "./DummyProfile.vue?vue&type=template&id=7ebc1ee7"
import script from "./DummyProfile.vue?vue&type=script&lang=js"
export * from "./DummyProfile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__